import us from '../us.svg';
import dk from "../dk.svg"

import '../App.css';
import { useParams, useNavigate} from 'react-router-dom';
import { Component } from 'react';
import { Link } from "react-router-dom";
import EnvironmentService from "../service/environmentService";
import MovieService from '../service/movieService';
import UserService from '../service/userService';
import LanguageService from '../service/languageService';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} Navigate={useNavigate()} />;
}


class MovieDetail extends Component {
    // var movies = [];

  constructor(props){
    super(props);

    this.environmentService = new EnvironmentService();
    this.UserService = new UserService();
    this.MovieService = new MovieService();
    this.LanguageService = new LanguageService();

    this.state = {
        movieVariants : [],
        movie : {},
        languageVariants: [],
        selectedLanguageVariant : null,
        selectedFile :null
    }
        this.handleChange = this.handleChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentDidMount(){

    this.getMoviesVariants();
    this.getMovieDetails();
    this.getUserInformation();
    this.getAllLanguageVariants();
  }

  showOverlay() {
      document.getElementById("overlay").style.display = "block";
    }

  hideOverlay() {
      document.getElementById("overlay").style.display = "none";
  }


  async getMovieDetails(){
     let result = await this.MovieService.GetMovieDetails(this.props.params.uuid)
    this.setState({
      movie : result
    });
  }

async getAllLanguageVariants(){
    let result = await this.LanguageService.GetLanguageOverview()
    this.setState({
      languageVariants : result
    });
}

  async getMoviesVariants(){
    let result = await this.MovieService.GetMovieVariants(this.props.params.uuid)
    this.setState({
      movieVariants : result
    });
  }

  handleChange({target}){
    console.log(target);
    this.setState({
        [target.name] : target.value
    });
}

  async getUserInformation(){
  let userObject= await this.UserService.getMe();
  
  this.setState({
    isUserAdmin :userObject.userRoles.includes("ADMIN")
  })

} 
  async UploadMovieVariant(event){
    event.preventDefault();

    this.MovieService.UploadMovieVariant(this.state.selectedFile,this.props.params.uuid,this.state.selectedLanguageVariant)
  }

  async handleFileChange(event){
    this.setState({
      selectedFile :event.target.files[0]
    })
  }

  renderLanguageImage(imageKey){
    var imageVariant;
    switch(imageKey){
      case "DA":
          imageVariant = dk;
          break;
      default:
        imageVariant = us;
          break;
      }
      return imageVariant
    }

  render(){
    const moviesVariant = this.state.movieVariants;
    if(!moviesVariant) return null;
    const movie = this.state.movie;
    if (!movie) return null;
    const isUserAdmin = this.state.isUserAdmin;
    const languageVariants = this.state.languageVariants;
    if(!languageVariants) return null;

    return(
       <div>
          <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>Upload Movie Variant</h1></center>
                        <form action="#" onSubmit={(event) => {this.UploadMovieVariant(event)}}>
                          <label>
                              Movie Variant
                          </label><br/>
                          <select name="selectedLanguageVariant" id="selectedLanguageVariant" onChange={this.handleChange} value={this.state.selectedLanguageVariant}>
                            <option value="none" selected disabled hidden>Select an Option</option>
                            {
                              languageVariants.map(language => (
                                <option value={language} key={language}>{this.state.movieVariants.includes(language) ? "[Reupload]"+language : language}  </option>
                              )) 
                            }
                          </select>

                          <input name="selectedFile" type="file" onChange={this.handleFileChange} />

                          <button type="submit">Submit</button>
                        </form>
                    </div>
          </div>

          <Link to={"/movies"}>Back</Link>
          <div>
            {
              isUserAdmin ?
              <button onClick={this.showOverlay}>Create New</button> : ""

            }
            <span className="page-title">Movies</span>
          </div>
          <div className="movieoverview"> 
          <p>{movie.name}</p>
          <div className="languages">
            {
              moviesVariant.map((movieVariant) =>(

              <div className="inner" key={movieVariant}>
                <div>
                  <Link key={movieVariant}  to={"/movie/stream/" + this.props.params.uuid+ "?variant=" + movieVariant }><img src={this.renderLanguageImage(movieVariant)} width="60px" height="60px" alt="HTML tutorial"/></Link>
                </div>
              </div>
              ))
            }       
            </div> 
          </div>
        </div> 
      )
  }
}

export default withParams(MovieDetail);
